// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see RemittanceSendShowCountryPickerEvent
 *
 * @deprecated This event is obsolete. Use `International Payments` instead.
 */
export var RemittanceSendShowCountryPicker = function (_a) {
    var preEnteredAmount = _a.preEnteredAmount, preEnteredAmountCurrency = _a.preEnteredAmountCurrency;
    return ({
        name: "Remittance Send ShowCountryPicker",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            pre_entered_amount: preEnteredAmount !== undefined && preEnteredAmount !== null ? preEnteredAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pre_entered_amount_currency: preEnteredAmountCurrency !== undefined && preEnteredAmountCurrency !== null ? preEnteredAmountCurrency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceSendInitiateEvent
 *
 * @deprecated This event is obsolete. Use `International Payments` instead.
 */
export var RemittanceSendInitiate = function (_a) {
    var deviceType = _a.deviceType, platformType = _a.platformType, platformVersion = _a.platformVersion, recipientSelected = _a.recipientSelected, repeatPayment = _a.repeatPayment, entryPoint = _a.entryPoint, destinationCountryCode = _a.destinationCountryCode, flowToken = _a.flowToken;
    return ({
        name: "Remittance Send Initiate",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            device_type: deviceType !== undefined && deviceType !== null ? deviceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            platform_type: platformType !== undefined && platformType !== null ? platformType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            platform_version: platformVersion !== undefined && platformVersion !== null ? platformVersion.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_selected: recipientSelected !== undefined && recipientSelected !== null ? recipientSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            repeat_payment: repeatPayment !== undefined && repeatPayment !== null ? repeatPayment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination_country_code: destinationCountryCode !== undefined && destinationCountryCode !== null ? destinationCountryCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceSendConvertEvent
 *
 * @deprecated This event is obsolete. Use `International Payments` instead.
 */
export var RemittanceSendConvert = function (_a) {
    var amountSent = _a.amountSent, amountReceived = _a.amountReceived, currencySent = _a.currencySent, currencyReceived = _a.currencyReceived, exchangeFlow = _a.exchangeFlow, exchangeRate = _a.exchangeRate, flowToken = _a.flowToken;
    return ({
        name: "Remittance Send Convert",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            amount_sent: amountSent !== undefined && amountSent !== null ? amountSent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_received: amountReceived !== undefined && amountReceived !== null ? amountReceived.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_sent: currencySent !== undefined && currencySent !== null ? currencySent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_received: currencyReceived !== undefined && currencyReceived !== null ? currencyReceived.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            exchange_flow: exchangeFlow !== undefined && exchangeFlow !== null ? exchangeFlow.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            exchange_rate: exchangeRate !== undefined && exchangeRate !== null ? exchangeRate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceSendDeliverEvent
 */
export var RemittanceSendDeliver = function (_a) {
    var methodSelected = _a.methodSelected, pickupLocation = _a.pickupLocation, showMore = _a.showMore, flowToken = _a.flowToken;
    return ({
        name: "Remittance Send Deliver",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            method_selected: methodSelected !== undefined && methodSelected !== null ? methodSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pickup_location: pickupLocation !== undefined && pickupLocation !== null ? pickupLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            show_more: showMore !== undefined && showMore !== null ? showMore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceSendEncounterUnsupportedNetworkErrorEvent
 */
export var RemittanceSendEncounterUnsupportedNetworkError = function (_a) {
    var unsupportedInstitution = _a.unsupportedInstitution, flowToken = _a.flowToken;
    return ({
        name: "Remittance Send EncounterUnsupportedNetworkError",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            unsupported_institution: unsupportedInstitution !== undefined && unsupportedInstitution !== null ? unsupportedInstitution.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceSendReviewEvent
 */
export var RemittanceSendReview = function (_a) {
    var action = _a.action, flowToken = _a.flowToken;
    return ({
        name: "Remittance Send Review",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceSendFailEvent
 */
export var RemittanceSendFail = function (_a) {
    var flowToken = _a.flowToken, phase = _a.phase, failureType = _a.failureType;
    return ({
        name: "Remittance Send Fail",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Send",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            phase: phase !== undefined && phase !== null ? phase.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_type: failureType !== undefined && failureType !== null ? failureType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceCancelInitiateEvent
 */
export var RemittanceCancelInitiate = function (_a) {
    var originalFlowToken = _a.originalFlowToken, copyVariant = _a.copyVariant, flowToken = _a.flowToken;
    return ({
        name: "Remittance Cancel Initiate",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Cancel",
            original_flow_token: originalFlowToken !== undefined && originalFlowToken !== null ? originalFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            copy_variant: copyVariant !== undefined && copyVariant !== null ? copyVariant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceCancelConfirmEvent
 */
export var RemittanceCancelConfirm = function (_a) {
    var reason = _a.reason, result = _a.result, failureReason = _a.failureReason, flowToken = _a.flowToken;
    return ({
        name: "Remittance Cancel Confirm",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "Cancel",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_reason: failureReason !== undefined && failureReason !== null ? failureReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see RemittanceNotificationMessageViewedEvent
 */
export var RemittanceNotificationMessageViewed = function (_a) {
    var originalFlowToken = _a.originalFlowToken, messageType = _a.messageType, flowToken = _a.flowToken;
    return ({
        name: "Remittance NotificationMessage Viewed",
        parameters: {
            cdf_entity: "Remittance",
            cdf_action: "NotificationMessage",
            original_flow_token: originalFlowToken !== undefined && originalFlowToken !== null ? originalFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_type: messageType !== undefined && messageType !== null ? messageType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
